// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"076ca88a","243":"b2f1643d","320":"1e74d0e3","455":"f11842be","508":"7d7b94a6","970":"e7dca0c1","977":"f4d16d5a"}[chunkId] + ".chunk.js";
};